import { render, staticRenderFns } from "./reservations_owner.vue?vue&type=template&id=68937588&scoped=true"
import script from "./reservations_owner.vue?vue&type=script&lang=js"
export * from "./reservations_owner.vue?vue&type=script&lang=js"
import style0 from "./reservations_owner.vue?vue&type=style&index=0&id=68937588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68937588",
  null
  
)

export default component.exports